module.exports = __webpack_public_path__ + "img/control-bg.07ca5d29.png";